import * as yup from 'yup'

const validationSchemaChecklist = (t) =>
  yup.object().shape({
    checklistId: yup.string().required(t('article.form.error.checklistId')),
    forStatus: yup.string().required(t('article.form.error.status')),
  })

export default validationSchemaChecklist
